<template>
  <div>
    <StartupListTopNav />
    <ScrollTopButton />
    <StartupList
      :followed-only="followedOnly"
      :show-recent="$attrs.showRecent"
      should-blur
    />
  </div>
</template>

<script>
import StartupList from 'modules/startup-list/StartupList.vue'
import StartupListTopNav from 'modules/startup-list/StartupListTopNav.vue'

export default {
  components: {
    StartupList,
    StartupListTopNav,
  },
  props: {
    followedOnly: { type: Boolean, default: false },
  },
}
</script>
